import {
  Button,
  Header,
  Table,
} from '@cloudscape-design/components';
import { projectFromFirestore } from '@parallel-fluidics/shared/models/projects';
import {
  collection,
  getFirestore,
  orderBy,
  where,
} from 'firebase/firestore';
import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import AddProjectModal from '../../components/Projects/addProjectModal';
import useCustomInfiniteQuery from '../../hooks/use-customInfiniteQuery';

export default function CustomerProjectsList() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [openAddProjectModal, setOpenAddProjectModal] = useState(false);

  const queryParams = useMemo(() => [
    collection(getFirestore(), 'projects'),
    where('isInternal', '==', false),
    orderBy('name', 'desc'),
  ], []);
  const {
    pageData, isFetchingNextPage, CustomPagination, refetch,
  } = useCustomInfiniteQuery({
    queryKey: 'getCustomerProjects',
    queryParams,
    pageSize: 25,
    transformData: projectFromFirestore,
  });

  const projectRows = useMemo(() => pageData.map((project) => ({
    ...project,
    projectId: (
      <Button
        variant="inline-link"
        onClick={() => navigate(`/projects/${project.id}?${searchParams.toString()}`)}
      >
        {project.name}
      </Button>
    ),
    filename: (
      <span style={{ whiteSpace: 'normal' }}>{project.filename}</span>
    ),
    notes: (
      <span style={{ whiteSpace: 'normal' }}>{project.notes}</span>
    ),
    linkButton: (
      <Button
        variant="inline-link"
        target="_blank"
        iconName="external"
        iconAlign="right"
        href={project.partId ? `/part/${project.partId}` : project.adminLink}
      >
        {project.partId || project.adminLink}
      </Button>
    ),
  })), [pageData, navigate, searchParams]);

  return (
    <>
      <Table
        header={(
          <Header
            variant="awsui-h1-sticky"
            actions={(
              <Button onClick={() => setOpenAddProjectModal(true)}>
                Create a Customer Project
              </Button>
            )}
          >
            Customer Projects
          </Header>
      )}
        variant="full-page"
        stickyHeader
        loading={isFetchingNextPage}
        items={projectRows}
        resizableColumns
        pagination={<CustomPagination />}
        columnDefinitions={[
          {
            id: 'name',
            header: 'Project ID',
            cell: (item) => item.projectId,
            width: 120,
          },
          {
            id: 'filename',
            header: 'File Name',
            cell: (item) => item.filename,
          },
          {
            id: 'partId',
            header: 'Part ID',
            cell: (item) => item.linkButton,
          },
          {
            id: 'notes',
            header: 'Notes',
            cell: (item) => item.notes,
          },
        ]}
      />
      {openAddProjectModal && (
        <AddProjectModal
          open={openAddProjectModal}
          onClose={() => setOpenAddProjectModal(false)}
          onSuccess={refetch}
        />
      )}
    </>
  );
}
